var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1241 5C13.1241 6.72589 11.7249 8.125 9.99905 8.125C8.27316 8.125 6.87405 6.72589 6.87405 5C6.87405 3.27411 8.27316 1.875 9.99905 1.875C11.7249 1.875 13.1241 3.27411 13.1241 5Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.7652C3.80859 13.3641 6.58395 10.625 9.99905 10.625C13.4142 10.625 16.1897 13.3642 16.2481 16.7654C14.3458 17.6383 12.2294 18.125 9.99932 18.125C7.76905 18.125 5.65247 17.6383 3.75 16.7652Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.02c7510f0dc47c0a61baec2cb73868be.svg";
export { ForwardRef as ReactComponent };